import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { btlApplicationFormApi } from '../../../api/btlApplicationForm';
import { AffordabilityRunRecord } from '../../../api/btlApplicationForm/types';

export const useGetAffordabilityCheck = (applicationId: string): UseQueryResult<AffordabilityRunRecord[]> =>
  useQuery(['btl-application-get-affordability-check', applicationId], () =>
    applicationId ? btlApplicationFormApi.getAffordabilityRuns(applicationId) : null,
  );
